export enum PageName {
    ContactUs = 'Contact Us',
    AboutEximpe = 'About Eximpe',
    Blog = 'Blog',
    HSCode = 'HSCode',
    InvoiceGenerator = 'Inoice Generator',
    SwiftCodeFinder = 'Swift Code Finder',
    GlobalCollection = 'Global Collection',
    GlobalTrade = 'Global Trade',
    Finance = 'Finance',
    PrivacyPolicy = 'Privacy Policy',
    Redressal = 'Redressal',
    RequestDemo = 'Request Demo',
    TermsAndConditions = 'Terms And Condition',
    PACBLanding = 'PACB Landing'

  }